import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled(Form)`
  width: 100%;

  display: flex;
  flex-direction: column;

  > div + div {
    margin-top: 1rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;
